/* eslint-disable no-unused-vars */
// Pubsub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
import { i18n } from "@i18n";
import store from "@store";
import { wdConfigData } from "@/service/wd_app_config.js";

// util
import {
  insert_slide_byTemplateFile,
  getOnePageTemplateById,
  addProductLogandTxt
} from "./gpt_addin_utils.js";

// VSTO Host Object
import { default as hostObject_slides } from "../vsto/vsto_slides.js";
import { default as hostObject_shapes } from "../vsto/vsto_shapes.js";
const vstoMode = store.get("app/vstoMode");

var PowerPoint = window.PowerPoint;

export async function add_slide_market_adoption(generateContent) {
  // 先随机选取模版，插入模版
  let template = getOnePageTemplateById("template_one_page_market_adoption");
  let templateUrl = `/${template.path}`;
  if (vstoMode) {
    let index = await hostObject_slides.vsto_insertSlideFromUrl(
      `${wdConfigData.baseURLTemplate}/${templateUrl}`
    );
    await hostObject_shapes.vsto_updateSlideContent_MarketAdoption(
      generateContent
    );
  } else {
    await insert_slide_byTemplateFile(`${wdConfigData.baseURLTemplate}/${templateUrl}`);
    await _updateSlideContent(generateContent);
    // await addProductLogandTxt()
  }

  publish(
    gptPubIds.pubId_Local_Addin_SystemLog,
    i18n.t("ppt_addin.process.text_ppt_generating_ppt_onepage_success")
  );
}

async function _updateSlideContent(generateContent) {
  PowerPoint = window.PowerPoint
  let dataJson = JSON.parse(generateContent);
  // 更改模版中的内容
  try {
    await PowerPoint.run(async function (context) {
      let selectedSlides = context.presentation.getSelectedSlides();
      selectedSlides.load("items");
      await context.sync();
      let selectedSlide = selectedSlides.items[0];
      selectedSlide.load("shapes");
      await context.sync();
      let shapeCollection = selectedSlide.shapes;
      shapeCollection.load("items");
      await context.sync();
      let shapes = shapeCollection.items;
  
      // shape数组数据
      for (let i = 0; i < shapes.length; i++) {
        // 一个Shape的JSON数据
        let shape = shapes[i];
        shape.load("$all");
        await context.sync();
  
        if (shape.name.startsWith("TextBox-Content")) {
          // shape text frame
          let textFrame = shape.textFrame;
          // text range
          textFrame.load("textRange", 'autoSizeSetting');
          await context.sync();
          textFrame.autoSizeSetting = PowerPoint.ShapeAutoSize.autoSizeTextToFitShape 
          await context.sync();
          let textRange = textFrame.textRange;
          textRange.load("$all");
          await context.sync();
  
          // 解析文本
          let content = "";
          switch (shape.name) {
            case "TextBox-Content-Innovators":
              content = dataJson["Innovators"];
              break;
            case "TextBox-Content-Early Adopters":
              content = dataJson["EarlyAdopters"];
              break;
            case "TextBox-Content-Early Majority":
              content = dataJson["EarlyMajority"];
              break;
            case "TextBox-Content-Late Majority":
              content = dataJson["LateMajority"];
              break;
            case "TextBox-Content-Laggards":
              content = dataJson["Laggards"];
              break;
          }
  
          // 更改TextBox文本
          textRange.text = content;
          await context.sync();

          // textRange.load("font", "size", "italic", "color", "bold")
          // await context.sync()
          
          // var textRangeTextFont = textRange.font
          // textRangeTextFont.size = 13.5
          // await context.sync()
        }
      }
    });
  } catch (error) {
    console.log("_updateSlideContent");
    publish(gptPubIds.pubId_Local_PPT_init_error, error);
  }
}
